"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSuperAdmin = void 0;
var SCOPE_SUPER_ADMIN = 'super-admin';

var isSuperAdmin = function isSuperAdmin(user) {
  return user.scopes.indexOf(SCOPE_SUPER_ADMIN) !== -1;
};

exports.isSuperAdmin = isSuperAdmin;